// === Task 23 === Flow Items panel extension
// Mounted from PluginToolbar.jsx when pluginToolbar.pluginId === "InteractivePlugin".
// Edits items[] inside pluginToolbarsById[boxId].state.
import React, { useState } from "react";
import i18n from "i18next";
import { connect } from "react-redux";
import { updatePluginToolbarItem, removePluginToolbarItem } from "../../../../common/actions";
import ItemPropertiesPanel from "./ItemPropertiesPanel";
import "./FlowItemsExtension.scss";

// === Task 20 === Pill grid removed — adding items is now driven from the
// left-rail "Interactive Elements" section. We keep the per-item list (delete
// + label) so existing items remain settable. Legacy per-item settings
// (startFrame, onCorrect/onWrong quick-actions) were removed under the
// canvas-first model — startFrame had no runtime consumer, and workflow
// events are now wired from the Workflow tab.

export function FlowItemsExtension({ boxId, items, selectedItemId, onRemoveItem }) {
  const [itemsOpen, setItemsOpen] = useState(true);

  const hasSelection = !!(selectedItemId && items.some((it) => it && it.id === selectedItemId));

  return (
    <div className="flow-items">
      {/* ── Selected element properties ── */}
      <div className="flow-items__section-head">
        <i className="material-icons">tune</i>
        <span>
          {hasSelection
            ? i18n.t("FlowItems.selected_element", { defaultValue: "Seçili Element" })
            : i18n.t("FlowItems.no_selection", { defaultValue: "Element Özellikleri" })}
        </span>
      </div>
      {hasSelection ? (
        <ItemPropertiesPanel boxId={boxId} />
      ) : (
        <div className="flow-items__no-selection">
          <i className="material-icons">touch_app</i>
          <span>
            {i18n.t("FlowItems.click_to_select", {
              defaultValue: "Özelliklerini düzenlemek için canvas'tan bir element seçin.",
            })}
          </span>
        </div>
      )}

      {/* ── Items list ── */}
      <button
        type="button"
        className="flow-items__section-head flow-items__section-head--toggle"
        onClick={() => setItemsOpen((o) => !o)}
        aria-expanded={itemsOpen}
      >
        <i className="material-icons">{itemsOpen ? "expand_more" : "chevron_right"}</i>
        <span>
          {i18n.t("FlowItems.title", { defaultValue: "ELEMENTLER" })} ({items.length})
        </span>
      </button>

      {itemsOpen && (
        <>
          <div className="legacy-flow-items-notice">
            <i className="material-icons">arrow_back</i>
            <span>
              {i18n.t("interactive.moved_to_left", {
                defaultValue:
                  "Add elements from the Interactive Elements section in the left rail.",
              })}
            </span>
          </div>
          {items.length === 0 && (
            <div className="flow-items__empty">
              {i18n.t("FlowItems.empty_after_move", {
                defaultValue: "No items yet — use the left rail to add one.",
              })}
            </div>
          )}
          {items.map((item, idx) => (
            <div
              key={item.id}
              className={`flow-items__item${item.id === selectedItemId ? " flow-items__item--selected" : ""}`}
            >
              <div className="flow-items__item-head">
                <span className="flow-items__item-num">{idx + 1}</span>
                <span className="flow-items__item-kind">{item.kind}</span>
                <button
                  type="button"
                  className="flow-items__delete"
                  onClick={() => onRemoveItem(item.id)}
                  aria-label={i18n.t("FlowItems.remove", { defaultValue: "Remove" })}
                >
                  ×
                </button>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  const present = (state.undoGroup && state.undoGroup.present) || state.undoGroup || state;
  const pluginToolbar =
    (present.pluginToolbarsById && present.pluginToolbarsById[ownProps.boxId]) || {};
  const items = (pluginToolbar.state && pluginToolbar.state.items) || [];
  const selectedItemId =
    state.interactivityStudio && state.interactivityStudio.selectedBoxId === ownProps.boxId
      ? state.interactivityStudio.selectedItemId
      : null;
  return { boxId: ownProps.boxId, items, selectedItemId };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onRemoveItem: (itemId) => dispatch(removePluginToolbarItem(ownProps.boxId, itemId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FlowItemsExtension);
// === /Task 23 ===
